import { UserMeProps } from '@/services/User/types';

// O retorno indexa `getMainRoute`, então nunca pode ser `undefined`: usuário
// sem `main_role` cai no default, como já caía o de papel vazio.
export const checkKeyMainRoute = (user: UserMeProps): string => {
  if (!user.main_role) return 'default';
  if (user.main_role !== 'Seazone') return user.main_role;
  if (user.seazone?.departmanet === 'Onboarding') return 'SeazoneOnboarding';
  if (user.seazone?.departmanet === 'Administrative') return 'SeazoneAdministrative';
  return 'default';
};

export const getMainRoute: Record<string, string> = {
  Admin: '/home',
  SeazoneOnboarding: '/home',
  SeazoneAdministrative: '/home',
  Attendant: '/home',
  Owner: '/proprietario',
  Host: '/home',
  Partner: '/parceiros/painel',
  Guest: '/login',
  default: '/login',
};
